import css from "styled-jsx/css";
import getColor, { COLOR_DICTIONARY } from "@gc-npm/utils.enums.colors";

export default css`
  .checkbox {
    display: block;
    flex-shrink: 0;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;

    user-select: none;
    z-index: 9;

    &--content {
      cursor: pointer;
      display: flex;

      &--input {
        position: absolute;
        opacity: 0;
        height: 0;
        width: 0;

        &:checked {
          ~ .checkbox--content--checkmark {
            border: solid 1px ${getColor(COLOR_DICTIONARY.BLUE_HIGH)};
            background-color: ${getColor(COLOR_DICTIONARY.BLUE_HIGH)};

            &:after {
              display: block;
            }
          }
        }

        &:checked {
          ~ .checkbox--content--checkmark--inverted {
            border: solid 2px ${getColor(COLOR_DICTIONARY.WHITE)};
            color: ${getColor(COLOR_DICTIONARY.BLUE_HIGH)};
            background-color: ${getColor(COLOR_DICTIONARY.WHITE)};

            &:after {
              color: ${getColor(COLOR_DICTIONARY.BLUE_HIGH)};
              display: block;
            }
          }
        }

        &:focus {
          ~ .checkbox--content--checkmark {
            box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.5);
          }
        }
      }

      &--checkmark {
        position: absolute;
        box-sizing: border-box;
        top: 0;
        left: 0;
        height: 20px;
        width: 20px;
        border: solid 2px #6B6C6F;
        border-radius: 4px;

        &:after {
          content: "";
          position: absolute;
          display: none;
          left: 6px;
          top: 1px;
          width: 6px;
          height: 14px;
          border: solid white;
          border-radius: 0 1px 0 1px;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
        }
      }

      &--checkmark--inverted {
        position: absolute;
        box-sizing: border-box;
        top: 0;
        left: 0;
        height: 20px;
        width: 20px;
        border: solid 2px white;
        border-radius: 4px;

        &:after {
          content: "";
          position: absolute;
          display: none;
          left: 6px;
          top: 0px;
          width: 6px;
          height: 14px;
          border: solid ${getColor(COLOR_DICTIONARY.BLUE_HIGH)};
          border-radius: 0 1px 0 1px;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
        }
      }

      &--checkmark--error {
        position: absolute;
        box-sizing: border-box;
        top: 0;
        left: 0;
        height: 20px;
        width: 20px;
        border: solid 2px red;
        border-radius: 4px;

        &:after {
          content: "";
          position: absolute;
          display: none;
          left: 6px;
          top: 1px;
          width: 6px;
          height: 14px;
          border: solid white;
          border-radius: 0 1px 0 1px;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
        }
      }
    }
  }
`;
